import React from "react";
function Main(_a) {
    var className = _a.className, env = _a.env, allowScroll = _a.allowScroll, isDemo = _a.isDemo, reset = _a.reset, applicationId = _a.applicationId, coverdashBackButton = _a.coverdashBackButton, hideChat = _a.hideChat, license = _a.license, autoResize = _a.autoResize, source = _a.source;
    var srcUrl = "https://quotes.".concat(env === "production" ? "" : "staging.", "coverdash.com?");
    srcUrl += "&isDemo=".concat(isDemo ? "true" : "false");
    srcUrl += "&license=".concat(license);
    if (reset) {
        srcUrl += "&reset=true";
    }
    if (applicationId) {
        srcUrl += "&applicationId=".concat(applicationId);
    }
    if (hideChat) {
        srcUrl += "&hideChat=true";
    }
    if (coverdashBackButton) {
        srcUrl += "&coverdashBackButton=true";
    }
    if (source) {
        srcUrl += "&source=".concat(source);
    }
    var _b = React.useState(true), loading = _b[0], setLoading = _b[1];
    React.useEffect(function () {
        if (autoResize) {
            var quotesIframe_1 = document.getElementById("coverdash-quotes-component");
            window.addEventListener("message", function (e) {
                if (isNaN(e.data))
                    return;
                // @ts-ignore
                quotesIframe_1.style.height = e.data + "px";
            }, false);
        }
    }, []);
    return (React.createElement("div", null,
        loading && (React.createElement("div", { className: "relative h-full ".concat(className, " bg-white h-[46rem]") },
            React.createElement("div", { className: "absolute left-0 right-0 mt-[16rem] h-60 max-w-3xl mx-auto text-center" },
                React.createElement("div", { className: "bg-gray-200 animate-pulse h-10 rounded-md" }),
                React.createElement("div", { className: "bg-gray-200 animate-pulse mt-24 w-44 h-14 rounded-md mx-auto" }),
                React.createElement("div", { className: "mt-10" },
                    React.createElement("p", { className: "text-sm" }, "Provided by"),
                    React.createElement("img", { className: "mx-auto", src: "https://iamyqpnnibrsxhgaflmh.supabase.co/storage/v1/object/public/images-public/png/coverdash_logo_new_light_transparent_shield.png", alt: "Coverdash logo", width: 140.6859, height: 24 }))))),
        React.createElement("div", { className: "".concat(loading && "hidden") },
            React.createElement("iframe", { onLoad: function () {
                    console.log("~ loaded coverdash quotes ~");
                    setLoading(false);
                }, title: "Coverdash Quotes", id: "coverdash-quotes-component", className: className, src: srcUrl, width: "100%", height: "800", scrolling: allowScroll ? "yes" : "no", frameBorder: "0" }))));
}
export default Main;
